module.exports = __webpack_public_path__ + "img/player3.f589d0a5.png";